import api from "../../utils/apiUser";

/**
 * Catalogos de atributos de una pieza.
 *
 * Vienen ordenados desde el backend por id, que es el orden en que se
 * quieren mostrar: por nombre, los certificados saldrian "C of C only"
 * antes de "Form 8130-3".
 */

export const getCondiciones = async () => {
  const res = await api.get("/api/atributos_producto/condiciones");
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export const getCertificados = async () => {
  const res = await api.get("/api/atributos_producto/certificados");
  return Array.isArray(res.data?.data) ? res.data.data : [];
};
